import type{ FileWithId } from 'src/types';

import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';

import { formatConfigJSON } from './config';

export enum PipelineName{
  CHATBOT = 'Chatbot_Pipeline',
  NOT_DEFINED = 'not_defined',
  CHAT_WITH_KNOWLEDGE_BASE = 'Chat_with_Knowledge_Base',
  CHAT_WITH_AUDIO = 'chat_with_audio_pipeline',
}

export enum PipelineType {
  NOT_DEFINED = 'NOT_DEFINED'
}

interface RunConfigRequest {
  pipeline_type?: string;
  intent_id: string;
  config?: {
    model_config?: ModelConfig;
    messages: Message[];
    fileName?: string;
  };
  upstream_linked_run_id?: string | null;
  downstream_linked_run_id?: string | null;
  audio_file?: FileWithId;
  mode?: string;
}

interface ModelConfig {
  model_name: string;
  max_output_token_length: number;
  temperature: number;
  top_p: number;
  top_k: number;
  knowledge_base?: string[];
  knowledge_base_type?: string;
}

interface Message {
  role: string;
  content: {
    type: string;
    [key: string]: string | string[] | undefined;
  }[];
}

export const createRun = async (data: RunConfigRequest) => {
  const { audio_file, mode, ...restData } = data;
  const _data = {
    pipeline_type: PipelineType.NOT_DEFINED,
    upstream_linked_run_id: null,
    downstream_linked_run_id: null,
    ...restData,
  };

  const chatMode = mode
    ? mode
    : (data.config?.model_config?.knowledge_base?.length ?? 0 > 0)
      ? 'chat_with_kb'
      : 'chat';

  const payload = {
    ..._data,
    config: formatConfigJSON(
      chatMode,
      data.config?.messages,
      data.config?.model_config,
      data.config?.fileName,
      audio_file
    ),
  };

  const response = await axios.post('/run_config', payload);
  return response.data;
};

export function useCreateRun() {
  const { mutate, isPending } = useMutation({
    mutationFn: createRun,
  });

  return { createRun: mutate, isRunPending: isPending };
}
